import {Ref, ref} from "vue";
import {LoadingState} from "@/services/contracts/LoadingState";
import {IInstitutionList} from "@/services/contracts/IInstitutionList";
import InstitutionService from "@/services/InstitutionService";
import {defineStore} from "pinia";
import {logError} from "@/services/support/error";

export const useInstitutionListStore
    = defineStore('institutions', () => {

    const EMPTY: IInstitutionList = {items: []};
    const loadingState = ref(LoadingState.LOADING);
    const list: Ref<IInstitutionList> = ref(EMPTY);

    async function fetch(competitionId: number | null) {

        console.debug('Fetching insititions...');
        loadingState.value = LoadingState.LOADING;

        if (competitionId == null) {
            list.value = EMPTY;
            loadingState.value = LoadingState.OK;
            return;
        }

        try {
            const response = await InstitutionService.find(competitionId);
            list.value = response.data;
            loadingState.value = LoadingState.OK;
        } catch (err) {
            list.value = EMPTY;
            loadingState.value = LoadingState.ERROR;
            logError('Failed to fetch institutions', err);
        }
    }

    return {list, loadingState, fetch}
});